import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import styled from '@emotion/styled';
import { colors } from '@modernhealth/vital-foundation';
import { ComponentTextSmall } from '../..';
import checkMark from './assets/checkmark.svg';
const Validation = styled.div(({ wasPasswordEdited, isValid }) => ({
    // eslint-disable-next-line no-nested-ternary
    color: isValid
        ? colors.violet55
        : wasPasswordEdited
            ? colors.red55
            : colors.gray55,
    lineHeight: '22px',
    paddingRight: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
}));
export const PasswordValidationElement = ({ wasPasswordEdited, isValid, text, testID }) => {
    return (_jsxs(Validation, { wasPasswordEdited: wasPasswordEdited, isValid: isValid, "data-testid": testID, children: [isValid ? (_jsxs("span", { children: [_jsx("img", { "data-testid": `${testID}-img`, src: checkMark, alt: "", "aria-invalid": isValid }), ' '] })) : (_jsx("span", { children: "\u2022 " })), _jsx(ComponentTextSmall, { children: text })] }));
};
